import { render, staticRenderFns } from "./myuserlevel.vue?vue&type=template&id=21853351&scoped=true&"
import script from "./myuserlevel.vue?vue&type=script&lang=js&"
export * from "./myuserlevel.vue?vue&type=script&lang=js&"
import style0 from "./myuserlevel.vue?vue&type=style&index=0&id=21853351&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21853351",
  null
  
)

export default component.exports